import { useEffect } from "react";

const siteUrl = (process.env.REACT_APP_PUBLIC_SITE_URL || "").replace(/\/$/, "");

const publicPages = {
  login: {
    path: "/",
    title: "Gestione Password | Password manager sicuro",
    description: "Gestione Password di AC Digital App: password manager web per organizzare e proteggere le credenziali personali.",
  },
  faq: {
    path: "/faq",
    title: "FAQ Gestione Password | AC Digital App",
    description: "Risposte essenziali su Gestione Password: piano Free, Premium, sicurezza delle credenziali e assistenza.",
  },
  privacy: {
    path: "/privacy",
    title: "Privacy Policy | Gestione Password",
    description: "Informativa privacy di Gestione Password: dati trattati, finalità, sicurezza e diritti dell'utente.",
  },
  terms: {
    path: "/terms",
    title: "Termini di Servizio | Gestione Password",
    description: "Termini di servizio di Gestione Password: piano Free, Premium, uso del servizio e assistenza.",
  },
};

const faqEntities = [
  ["Che cos'è Gestione Password?", "È un'applicazione web di AC Digital App per organizzare credenziali personali e password in un vault protetto da autenticazione."],
  ["Quali piani sono disponibili?", "Il piano Free consente fino a 10 password. Il piano Premium costa 2,99 € al mese e include password illimitate."],
  ["Come vengono protette le credenziali?", "L'accesso richiede email e password. Le comunicazioni avvengono su HTTPS e le voci del vault sono cifrate prima del salvataggio."],
  ["Come posso richiedere assistenza o la cancellazione dell'account?", "Puoi contattare AC Digital App all'indirizzo acdigital.app@gmail.com."],
];

function setMeta(name, content, property = false) {
  const selector = property ? `meta[property="${name}"]` : `meta[name="${name}"]`;
  let element = document.head.querySelector(selector);
  if (!element) {
    element = document.createElement("meta");
    if (property) element.setAttribute("property", name);
    else element.setAttribute("name", name);
    document.head.appendChild(element);
  }
  element.setAttribute("content", content);
}

function setStructuredData(page, canonical) {
  const id = "site-structured-data";
  let script = document.getElementById(id);
  if (!script) {
    script = document.createElement("script");
    script.id = id;
    script.type = "application/ld+json";
    document.head.appendChild(script);
  }
  const organization = {
    "@type": "Organization",
    name: "AC Digital App",
    url: siteUrl,
    email: "acdigital.app@gmail.com",
  };
  const pageData = page === "faq"
    ? { "@context": "https://schema.org", "@type": "FAQPage", mainEntity: faqEntities.map(([name, text]) => ({ "@type": "Question", name, acceptedAnswer: { "@type": "Answer", text } })) }
    : {
        "@context": "https://schema.org",
        "@graph": [
          organization,
          {
            "@type": "SoftwareApplication",
            name: "Gestione Password",
            applicationCategory: "SecurityApplication",
            operatingSystem: "Web",
            url: canonical,
            provider: { "@type": "Organization", name: "AC Digital App" },
            offers: { "@type": "Offer", price: "2.99", priceCurrency: "EUR", description: "Piano Premium mensile" },
          },
        ],
      };
  script.textContent = JSON.stringify(pageData);
}

export function useSeo(page) {
  useEffect(() => {
    const meta = publicPages[page] || publicPages.login;
    const canonical = `${siteUrl}${meta.path}`;
    document.title = meta.title;
    setMeta("description", meta.description);
    setMeta("robots", "index,follow");
    setMeta("og:title", meta.title, true);
    setMeta("og:description", meta.description, true);
    setMeta("og:url", canonical, true);
    let canonicalElement = document.head.querySelector('link[rel="canonical"]');
    if (!canonicalElement) {
      canonicalElement = document.createElement("link");
      canonicalElement.setAttribute("rel", "canonical");
      document.head.appendChild(canonicalElement);
    }
    canonicalElement.setAttribute("href", canonical);
    setStructuredData(page, canonical);
  }, [page]);
}